/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  folder: {
    width: 16,
    height: 12,
    viewBox: '0 0 16 12',
    data:
      '<path pid="0" d="M.79 0h2.876a.8.8 0 0 1 .506.18l.91.743a.2.2 0 0 0 .127.045h8.228c.437 0 .79.346.79.774v1.742c0 .107.089.193.198.193h.79a.777.777 0 0 1 .765.943l-1.61 6.781a.787.787 0 0 1-.77.599H.79a.782.782 0 0 1-.79-.774V.774C0 .347.354 0 .79 0zm12.647 3.484V1.935a.196.196 0 0 0-.198-.193H5.138a.8.8 0 0 1-.506-.18L3.72.82a.2.2 0 0 0-.127-.045H.988A.196.196 0 0 0 .79.968V9.04c0 .032.026.058.06.058a.059.059 0 0 0 .057-.045l1.125-4.776a.787.787 0 0 1 .77-.6H13.24c.11 0 .198-.087.198-.194zM1.434 11.226h12.009a.197.197 0 0 0 .192-.15l1.517-6.387a.193.193 0 0 0-.193-.237L3.096 4.45a.394.394 0 0 0-.385.3l-1.47 6.238a.193.193 0 0 0 .193.237z" _fill="#000" fill-rule="nonzero"/>'
  }
})
